export const PKCE_VERIFIER_KEY = 'PKCE_verifier';
function makeKey(subKey) {
    if (!subKey) {
        return PKCE_VERIFIER_KEY;
    }
    return `${PKCE_VERIFIER_KEY}.${subKey}`;
}
export function setPkceVerifier(PkceVerifier, subKey) {
    localStorage.setItem(makeKey(subKey), PkceVerifier);
}
export function getPkceVerifier(subKey) {
    var _a;
    return (_a = localStorage.getItem(makeKey(subKey))) !== null && _a !== void 0 ? _a : '';
}
export function clearPkceVerifier(subKey) {
    localStorage.removeItem(makeKey(subKey));
}
//# sourceMappingURL=pkceFlowHelpers.js.map